import { render, staticRenderFns } from "./MenuDoctor.vue?vue&type=template&id=76840180&"
import script from "./MenuDoctor.vue?vue&type=script&lang=js&"
export * from "./MenuDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports